import type { SvelteComponent } from 'svelte';
import { writable } from 'svelte/store';

interface ConfirmationModal {
	type: 'ConfirmationModal';
	title: string;
	message?: string;
	confirmText?: string;
	cancelText?: string | false;
	resolve: () => void;
	reject: (message: string) => void;
}
interface CustomModal {
	type: 'CustomModal';
	component: typeof SvelteComponent;
	resolve: (value?: any) => void;
	reject: (message: string) => void;
	props: Record<string, unknown>;
}
type ConfirmationModalOptions = Omit<ConfirmationModal, 'resolve' | 'reject' | 'type'>;
export const modalStack = writable<(ConfirmationModal | CustomModal)[]>([]);

let defaultConfirmText = 'Confirm';
let defaultCancelText = 'Cancel';
export function setConfirmText(text: string) {
	defaultConfirmText = text;
}
export function setCancelText(text: string) {
	defaultCancelText = text;
}

export function confirmationModal({
	title,
	message,
	confirmText = defaultConfirmText,
	cancelText = defaultCancelText,
}: ConfirmationModalOptions) {
	return new Promise<void>((resolve, reject) => {
		modalStack.update(($modals) => [
			...$modals,
			{ type: 'ConfirmationModal', title, message, confirmText, cancelText, resolve, reject },
		]);
	});
}
export function customModal<T = void>(
	component: typeof SvelteComponent,
	props: Record<string, unknown>
) {
	return new Promise<T>((resolve, reject) => {
		modalStack.update(($modals) => [
			...$modals,
			{ type: 'CustomModal', component, resolve, reject, props },
		]);
	});
}

(window as any).confirmationModal = confirmationModal;
